import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  title: {
    fontFamily: 'Nouvelle',
    paddingTop: '10px',
    paddingBottom: '2px'
  }
}))
